// Utility functions for handling DynamoDB composite key formats

/**
 * Extract UUID from trip ID
 * Format: TRIP#6ef011cb-f9d1-497d-bdd5-1383d29684dd
 * Returns: 6ef011cb-f9d1-497d-bdd5-1383d29684dd
 */
export const extractTripUuid = (tripId: string | number): string => {
  const id = String(tripId);
  if (id.startsWith('TRIP#')) {
    return id.replace('TRIP#', '');
  }
  return id;
};

/**
 * Extract UUID from activity ID
 * Format: TRIP#6ef011cb-f9d1-497d-bdd5-1383d29684dd#ACTIVITY#uuid
 * Returns: uuid (the last part after the last #)
 */
export const extractActivityUuid = (activityId: string): string => {
  const parts = activityId.split('#');
  return parts[parts.length - 1];
};

/**
 * Build full trip ID from UUID
 * Input: 6ef011cb-f9d1-497d-bdd5-1383d29684dd
 * Returns: TRIP#6ef011cb-f9d1-497d-bdd5-1383d29684dd
 */
export const buildTripId = (uuid: string): string => {
  if (uuid.startsWith('TRIP#')) {
    return uuid;
  }
  return `TRIP#${uuid}`;
};

/**
 * Build full activity ID from trip UUID and activity UUID
 * Input: tripUuid, activityUuid
 * Returns: TRIP#tripUuid#ACTIVITY#activityUuid
 */
export const buildActivityId = (tripUuid: string, activityUuid: string): string => {
  const tripId = buildTripId(tripUuid);
  return `${tripId}#ACTIVITY#${activityUuid}`;
};
